import { PlusCircleOutlined } from '@ant-design/icons';
import { useDebounce } from '@hooks';
import { FilterHeader } from '@organisms';
import { Button, Input } from 'antd';
import React, { useEffect, useState } from 'react';

interface FilterUpsellFlowsProps {
  onAddUpsellFlows: () => void;
  onFilterUpsellFlows: (handle: { field: string; value?: string }[]) => void;
}

export const FilterUpsellFlows: React.FC<FilterUpsellFlowsProps> = ({
  onAddUpsellFlows,
  onFilterUpsellFlows,
}) => {
  const [filterSearch, setFilterSearch] = useState<string | null>(null);

  const debounceValue = useDebounce(filterSearch ?? '', 900);

  useEffect(() => {
    if (filterSearch !== null) {
      onFilterUpsellFlows([
        {
          field: 'filter',
          value: debounceValue,
        },
      ]);
    }
  }, [debounceValue]);

  return (
    <FilterHeader
      buttonList={[
        <Input.Search
          key={`filter-flow-search`}
          placeholder={'Buscar por id ou nome'}
          value={filterSearch ?? ''}
          onChange={evt => setFilterSearch(evt.target.value)}
          style={{ width: '560px' }}
          allowClear
        />,
      ]}
      customFilter={[
        <Button
          key={'filter-header-button-add-assets'}
          icon={<PlusCircleOutlined />}
          type='primary'
          onClick={onAddUpsellFlows}
        >
          Adicionar Fluxo
        </Button>,
      ]}
    />
  );
};
